// Utilità per controlli di contabilità

export const controllaQuadratura = (dettagli) => {
  if (!dettagli || dettagli.length === 0) {
    return {
      isQuadrato: false,
      sommaDare: 0,
      sommaAvere: 0,
      sbilancio: 0,
      errore: 'Nessun dettaglio inserito'
    };
  }

  const sommaDare = dettagli
    .filter(d => d.importo > 0)
    .reduce((sum, d) => sum + parseFloat(d.importo || 0), 0);

  const sommaAvere = Math.abs(
    dettagli
      .filter(d => d.importo < 0)
      .reduce((sum, d) => sum + parseFloat(d.importo || 0), 0)
  );

  const sbilancio = sommaDare - sommaAvere;
  const isQuadrato = Math.abs(sbilancio) < 0.01; // Tolleranza per decimali

  return {
    isQuadrato,
    sommaDare,
    sommaAvere,
    sbilancio,
    errore: isQuadrato ? null : `Sbilancio di €${Math.abs(sbilancio).toFixed(2)}`
  };
};

export const formattaValuta = (importo) => {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR'
  }).format(importo);
};

export const getTipoRiga = (importo) => {
  return importo >= 0 ? 'D' : 'A';
};
